
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-insights",
      function () {
        return require("private-next-pages/real-estate-insights/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-insights"])
      });
    }
  